export const directions = {
  "directions.directions.get": "directions.directions.get",
  "directions.directions.create": "directions.directions.create",
  "directions.directions.update": "directions.directions.update",
  "directions.directions.delete": "directions.directions.delete",
} as const;
